import React from 'react';
import Footer from '../../component-library/navigation/Footer/default';
import styled from '@emotion/styled';
import Link from 'next/link';
import LegacyStaticPageLink from '../../component-library/navigation/LegacyStaticPageLink';
import { colors, breakpoints } from '../../../utils/styleguide';
import Typography from '../../component-library/text/Typography';
import { FooterPagesItemType } from '../../component-library/navigation/navTypes';

const LinkWrapper = styled.div`
  margin: 15px 0;
  flex-basis: 50%;
  ${breakpoints.tablet} {
    flex-basis: 33%;
  }
`;

const NavLink = styled(Typography)`
  transition: color 0.3s ease;
  color: ${colors.white};
  text-decoration: none;
  border-bottom: 1px solid ${colors.white};
  padding-bottom: 4px;
`;

NavLink.defaultProps = {
  variant: 'body',
  tag: 'a',
};

type Props = {
  pages?: FooterPagesItemType[];
  showLanguageSelection?: boolean;
  hasMobileStaticButton?: boolean;
};

const DefaultFooter = ({ pages, showLanguageSelection, hasMobileStaticButton = false }: Props) => {
  return (
    <Footer
      showLanguageSelection={showLanguageSelection}
      hasMobileStaticButton={hasMobileStaticButton}
      navigationLinks={
        pages &&
        pages.map((page) => (
          <LinkWrapper key={page.id}>
            <FooterLink page={page}>
              <NavLink useBuiltInMargins>{page.title}</NavLink>
            </FooterLink>
          </LinkWrapper>
        ))
      }
    />
  );
};

type LinkProps = {
  page: FooterPagesItemType;
  children: React.ReactNode;
};

const FooterLink = ({ page, children }: LinkProps) => {
  if (page.contentTypeId === 'staticLink')
    return (
      <Link href={`/${page.slug}`} passHref>
        {children}
      </Link>
    );

  return <LegacyStaticPageLink slug={page.slug}>{children}</LegacyStaticPageLink>;
};

export default DefaultFooter;
